import React, { Component } from 'react';

export class ErrorPage extends Component {
    displayName = ErrorPage.name

    constructor(props) {
        super(props);
    }

    render() {
        return (
            this.props.small ?
                <h4> Loading... <i className="fas fa-spinner fa-spin"></i> </h4>
                :
                <div className="error" style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <div style={{ textAlign: "center" }}>
                        <div style={{ marginTop: "15px" }}>
                            {
                                //<i className="fas fa-exclamation-triangle fa-3x"></i>
                            }
                            <i className="fas fa-frown fa-4x"></i>
                        </div>
                        <h1 className="error">Oops.. Something went wrong!</h1>
                        <p className="error">And error occured while trying to process your request</p>
                    </div>
                </div>
        );
    }
}

ErrorPage.defaultProps = {
    small: false
}


// WEBPACK FOOTER //
// ./src/components/ErrorPage.js